<template>
  <div id=".resultadoPases">
    <v-card>
      <v-card-title primary-title style="height: 125px" class="pl-1 pr-1">
        <v-layout row wrap>
          <v-flex xs12>
            <h3 class="title mb-0 text-xs-center text-capitalize">
              {{ pase.pase.nombre.toLowerCase() }}
            </h3>
            <v-icon small color="blue darken-1" class="cur-pointer float-right" @click="showDetallePase(pase.pase)"
              >fas fa-info-circle</v-icon
            >
          </v-flex>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-container grid-list-md text-xs-center class="pa-0">
          <v-layout row wrap justify-space-around>
            <v-flex xs6 v-for="(t, tpi) in limpiarTarifas(pase.pase.tarifas.tarifa)" :key="tpi">
              <p class="mb-0 font-weight-bold green--text darken-4">
                {{ t.moneda }} {{ (t.venta / t["@attributes"].pax).toFixed(2) }}
              </p>
              <p class="caption font-weight-light" v-if="t['@attributes'].tipo == 'adl'">
                Precio por adulto
              </p>
              <p class="caption font-weight-light" v-if="t['@attributes'].tipo == 'chd'">
                Precio por menor
              </p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn block color="success" v-if="isSeleccionado">
          <v-icon small>
            fas fa-check
          </v-icon>
        </v-btn>
        <v-btn block color="primary" v-if="!isSeleccionado" @click="agregarPase" data-cy="btnTktAgregar">
          {{ pase.comparador == undefined ? "Agregar" : "Seleccionar" }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogPase" max-width="590">
      <v-card>
        <v-card-title class="headline red darken-4 text-xs-center" primary-title>
          <p class="text-white">
            {{ dialogData.nombre }}
          </p>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <v-layout row wrap justify-space-around>
              <v-flex xs12>
                {{ dialogData.descripcion }}
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red" flat="flat" @click="dialogPase = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "panelPase",
  props: ["pase"],
  components: {},
  mounted() {},
  created() {},
  methods: {
    showDetallePase(pase) {
      this.dialogData = pase
      this.dialogPase = true
    },
    agregarPase() {
      if (this.pase.comparador != undefined) {
        this.asignar2Habitacion()
        return
      }
      this.$store.dispatch("carrito/agregarPase", this.pase.pase)
      this.showToasted("El pase fue agregado al carrito", "success")
      this.$store.commit("carrito/setOpen", true)
    },
    async asignar2Habitacion() {
      let toas = {
        tipo: "error",
        mensaje: "No se pudo asignar el pase a la habitación"
      }
      const rs = await this.$store.dispatch("carrito/agregarPase2Habitacion", this.pase)
      if (rs) {
        toas = { tipo: "success", mensaje: "Pase asignado a la habitación" }
        this.$store.commit("carrito/setOpen", true)
      }
      this.showToasted(toas.mensaje, toas.tipo)
    },
    isInHabitacion() {
      let _this = this
      const indice = this.servicios.hoteles.findIndex(h => {
        try {
          const indice = h.habitaciones
            .find(hab => hab.habitacion.comparador === _this.pase.comparador)
            .habitacion.tickets.findIndex(t => _this.pase.pase.unico_consulta === t.unico_consulta)
          return indice === -1 ? false : true
        } catch (e) {
          return false
        }
      })
      return indice === -1 ? false : true
    },
    isInCarrito() {
      let _this = this
      const inCarrito = this.servicios.tickets.some(t => _this.pase.pase.unico_consulta === t.unico_consulta)
      return inCarrito
    },
    limpiarTarifas(crudo) {
      const limpios = this.toArray(crudo).filter(c => c["@attributes"].tipo != "total")
      return limpios
    }
  },
  data() {
    return {
      dialogPase: false,
      dialogData: {}
    }
  },
  computed: {
    ...mapGetters("carrito", {
      servicios: "cartServicios"
    }),
    isSeleccionado() {
      const inHabitacion = this.isInHabitacion()
      const inCarrito = this.isInCarrito()
      return inHabitacion || inCarrito
    }
  }
}
</script>
